var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIaInterview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 217,
    viewBox: "0 0 193 217",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "i81bg721jc"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F4F9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0CFE5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "0pyz5bxite"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF8FF",
    stopOpacity: 0.5,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05429F",
    stopOpacity: 0.223,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "41.741%",
    id: "wfjlxwwwzf"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0.5,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "txcmm7y4mh"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90CAF9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "42lyl9wfzj"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF8FF",
    stopOpacity: 0.5,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05429F",
    stopOpacity: 0.223,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "41.741%",
    id: "dnjw34ti9k"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0.5,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "45.424%",
    y1: "100%",
    x2: "54.576%",
    y2: "3.226%",
    id: "2t88bnj4dm"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CED7",
    stopOpacity: 0.269,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55616E",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "47.141%",
    y1: "100%",
    x2: "52.859%",
    y2: "3.226%",
    id: "croapukntn"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CED7",
    stopOpacity: 0.269,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55616E",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "29.672%",
    y1: "0%",
    x2: "70.328%",
    y2: "100%",
    id: "0j87yqy9co"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CED7",
    stopOpacity: 0.269,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91A0AF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "69.966%",
    y1: "0%",
    x2: "30.034%",
    y2: "97.778%",
    id: "3gu1iwz2hp"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CED7",
    stopOpacity: 0.269,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91A0AF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "ztuylreaaq"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A65C2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#152235",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "zchrhqzsbu"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "xiijngvq7y"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8F5FD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0D4FA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "epyougw1sz"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8F5FD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0D4FA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "4wo3kjwdkA"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8F5FD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0D4FA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "fzhg8yzf3B"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8F5FD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0D4FA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-24.8%",
    y: "-10.7%",
    width: "149.6%",
    height: "134.4%",
    filterUnits: "objectBoundingBox",
    id: "t6p51lep0a"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.268793706 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-2.4%",
    y: "-2.8%",
    width: "104.8%",
    height: "105.6%",
    filterUnits: "objectBoundingBox",
    id: "6mi1l0otxg"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.756009615 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-6.4%",
    y: "-4.9%",
    width: "112.7%",
    height: "109.8%",
    filterUnits: "objectBoundingBox",
    id: "pelb8q36il"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.756009615 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-5.7%",
    y: "-8.6%",
    width: "111.5%",
    height: "117.3%",
    filterUnits: "objectBoundingBox",
    id: "6idsmtkx7t"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0",
    in: "shadowInnerInner1",
    result: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetInner2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner2",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.274251501 0 0 0 0 0.386842884 0 0 0 0 0.582653986 0 0 0 1 0",
    in: "shadowInnerInner2",
    result: "shadowMatrixInner2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner2"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-242%",
    y: "-249.6%",
    width: "584%",
    height: "599.2%",
    filterUnits: "objectBoundingBox",
    id: "057ikv0zjv"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.957,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-116.3%",
    y: "-64.2%",
    width: "332.5%",
    height: "228.5%",
    filterUnits: "objectBoundingBox",
    id: "s3w3yjepww"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.708,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-116.3%",
    y: "-64.2%",
    width: "332.5%",
    height: "228.5%",
    filterUnits: "objectBoundingBox",
    id: "f7bjd89qtx"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.708,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.786 15.924c4.502-3.98 9.523-5.887 15.064-5.721 6.8-.033 12.238 2.206 16.316 6.717 6.116 6.766 6.116 20.053 1.756 24.465-2.907 2.94-8.93 4.456-18.072 4.546-9.137-.08-15.161-1.595-18.073-4.546-4.367-4.428-3.743-19.492 3.01-25.461z",
    id: "eqf3k28cod"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.85 0c2.17 0 3.928 1.703 3.928 3.803 0 1.673-1.117 3.094-2.668 3.603v2.787h-2.606V7.379C18 6.85 16.92 5.45 16.92 3.803 16.921 1.703 18.68 0 20.85 0z",
    id: "njwyhsz35i"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.851 23.473c3.817-3.477 8.79-3.89 13.986-3.905 4.865-.014 9.782.244 13.959 3.905 4.176 3.662 3.508 12.057 2.3 14.48-1.207 2.422-7.767 3.868-16.246 3.868-8.48 0-14.889-1.715-16.343-3.869C3.052 35.8 3.035 26.951 6.85 23.473z",
    id: "ls78l3sb8r"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "0%",
    fx: "50%",
    fy: "0%",
    r: "91.767%",
    gradientTransform: "matrix(0 1 -.6467 0 .5 -.5)",
    id: "kf7va4mhcs"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#164091",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C1645",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "svmvfgp64b",
    x: 0,
    y: 0,
    width: 127,
    height: 183,
    rx: 10
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(45 5)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#t6p51lep0a)",
    xlinkHref: "#svmvfgp64b"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#5DCEF9",
    strokeWidth: 0.5,
    strokeLinejoin: "square",
    fill: "#20C1F8",
    x: 0.25,
    y: 0.25,
    width: 126.5,
    height: 182.5,
    rx: 10
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66 115)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    width: 86,
    height: 12.568,
    rx: 6.284
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#BDCAD0",
    x: 15.229,
    y: 3.591,
    width: 62.708,
    height: 1.795,
    rx: 0.898
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#BDCAD0",
    x: 15.229,
    y: 7.182,
    width: 44.792,
    height: 1.795,
    rx: 0.898
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.538 6.284a3.743 3.743 0 0 0 3.733 3.74 3.743 3.743 0 0 0 3.733-3.74 3.743 3.743 0 0 0-3.733-3.74 3.743 3.743 0 0 0-3.733 3.74zm3.4 1.26a.28.28 0 0 1-.395 0L4.487 6.487a.283.283 0 0 1 0-.396.281.281 0 0 1 .395 0l.859.86 1.918-1.923a.281.281 0 0 1 .396 0 .283.283 0 0 1 0 .397L5.94 7.544z",
    fill: "#44CB67"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66 136)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    width: 86,
    height: 12.568,
    rx: 6.284
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#BDCAD0",
    x: 15.229,
    y: 3.591,
    width: 62.708,
    height: 1.795,
    rx: 0.898
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#BDCAD0",
    x: 15.229,
    y: 7.182,
    width: 44.792,
    height: 1.795,
    rx: 0.898
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.538 6.284a3.743 3.743 0 0 0 3.733 3.74 3.743 3.743 0 0 0 3.732-3.74 3.743 3.743 0 0 0-3.732-3.74 3.743 3.743 0 0 0-3.733 3.74z",
    fill: "#F61F1F"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.32 7.247a.22.22 0 0 1 0-.31l1.65-1.65a.22.22 0 0 1 .31 0 .22.22 0 0 1 0 .309l-1.651 1.65a.212.212 0 0 1-.155.065.216.216 0 0 1-.154-.064z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.97 7.247 5.32 5.596a.22.22 0 0 1 0-.31.22.22 0 0 1 .309 0l1.65 1.652a.22.22 0 0 1 0 .309.216.216 0 0 1-.154.064.216.216 0 0 1-.154-.064z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66 157)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    width: 86,
    height: 12.568,
    rx: 6.284
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#BDCAD0",
    x: 15.229,
    y: 3.591,
    width: 62.708,
    height: 1.795,
    rx: 0.898
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#BDCAD0",
    x: 15.229,
    y: 7.182,
    width: 44.792,
    height: 1.795,
    rx: 0.898
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.538 6.284a3.743 3.743 0 0 0 3.733 3.74 3.743 3.743 0 0 0 3.733-3.74 3.743 3.743 0 0 0-3.733-3.74 3.743 3.743 0 0 0-3.733 3.74zm3.4 1.26a.28.28 0 0 1-.395 0L4.487 6.487a.283.283 0 0 1 0-.396.281.281 0 0 1 .395 0l.859.86 1.918-1.923a.281.281 0 0 1 .396 0 .283.283 0 0 1 0 .397L5.94 7.544z",
    fill: "#44CB67"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88 19)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#152235",
    opacity: 0.13,
    cx: 21,
    cy: 53.768,
    rx: 18.789,
    ry: 1.64
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#152235",
    opacity: 0.09,
    cx: 21,
    cy: 62.517,
    rx: 11.053,
    ry: 1.64
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#152235",
    opacity: 0.05,
    cx: 21,
    cy: 72.36,
    rx: 6.632,
    ry: 1.64
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#i81bg721jc)",
    xlinkHref: "#eqf3k28cod"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#0pyz5bxite)",
    xlinkHref: "#eqf3k28cod"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#wfjlxwwwzf)",
    xlinkHref: "#eqf3k28cod"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#6mi1l0otxg)",
    xlinkHref: "#eqf3k28cod"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#txcmm7y4mh)",
    xlinkHref: "#njwyhsz35i"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#42lyl9wfzj)",
    xlinkHref: "#njwyhsz35i"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#dnjw34ti9k)",
    xlinkHref: "#njwyhsz35i"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#pelb8q36il)",
    xlinkHref: "#njwyhsz35i"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.278 40.592c.096 1.173.047 2.097-.145 2.772a2.831 2.831 0 0 1-1.13 1.598",
    stroke: "#FFF",
    strokeWidth: 0.924,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.136 40.592c.096 1.173.048 2.097-.144 2.772a2.831 2.831 0 0 1-1.13 1.598",
    stroke: "url(#2t88bnj4dm)",
    strokeWidth: 0.924,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.314 40.444c-.1 1.268-.05 2.276.15 3.026s.494 1.247.88 1.492",
    stroke: "#FFF",
    strokeWidth: 0.924,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.455 40.444c-.1 1.268-.05 2.276.151 3.026.2.75.493 1.247.88 1.492",
    stroke: "url(#croapukntn)",
    strokeWidth: 0.924,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.134 10.539c2.314 1.496 4.017 3.14 5.11 4.932 1.092 1.792 1.746 3.845 1.961 6.159",
    stroke: "#FFF",
    strokeWidth: 0.924,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.957 10.573c2.314 1.496 4.018 3.14 5.11 4.933 1.092 1.792 1.746 3.844 1.962 6.158",
    stroke: "url(#0j87yqy9co)",
    strokeWidth: 0.924,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.35 10.573c-2.335 1.667-4.014 3.351-5.035 5.053s-1.679 3.715-1.973 6.038",
    stroke: "#FFF",
    strokeWidth: 0.924,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.563 10.573c-2.337 1.667-4.015 3.351-5.036 5.053s-1.679 3.715-1.973 6.038",
    stroke: "url(#3gu1iwz2hp)",
    strokeWidth: 0.924,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "url(#ztuylreaaq)",
    xlinkHref: "#ls78l3sb8r"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#kf7va4mhcs)",
    xlinkHref: "#ls78l3sb8r"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#6idsmtkx7t)",
    xlinkHref: "#ls78l3sb8r"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#zchrhqzsbu)",
    strokeWidth: 0.924,
    d: "M20.835 19.106c4.98-.014 9.997.278 14.265 4.02 1.8 1.578 2.755 3.99 3.15 6.47.555 3.492-.007 7.092-.74 8.563-.632 1.267-2.595 2.346-5.584 3.057-2.892.69-6.735 1.067-11.076 1.067-8.743 0-15.238-1.868-16.726-4.072-.86-1.273-1.286-4.784-.722-8.266.428-2.646 1.42-5.248 3.138-6.813 3.901-3.554 8.976-4.01 14.295-4.026z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#E8F5FD",
    opacity: 0.088,
    filter: "url(#057ikv0zjv)",
    cx: 20.824,
    cy: 29.085,
    rx: 7.412,
    ry: 7.186
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#E8F5FD",
    filter: "url(#s3w3yjepww)",
    x: 10.214,
    y: 26.899,
    width: 4.408,
    height: 7.977,
    rx: 2.204
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#E8F5FD",
    filter: "url(#f7bjd89qtx)",
    x: 27.078,
    y: 26.899,
    width: 4.408,
    height: 7.977,
    rx: 2.204
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#E8F5FD",
    x: 10.214,
    y: 26.899,
    width: 4.408,
    height: 7.977,
    rx: 2.204
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#E8F5FD",
    x: 27.078,
    y: 26.899,
    width: 4.408,
    height: 7.977,
    rx: 2.204
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.021 74c-9.585-9.674-11.303-16.615-5.156-20.821 9.221-6.31 27.065-12.012 26.097-25.77C70.995 13.65 60.525 3.264 45.865.659c-14.66-2.606-31.05 2.759-39.7 11.946-8.651 9.187-8.493 18.998 2.355 31.108C15.752 51.785 29.919 61.88 51.021 74z",
    fill: "url(#xiijngvq7y)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#23A9F6",
    x: 9.525,
    y: 20.408,
    width: 32.151,
    height: 1.508,
    rx: 0.754
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#23A9F6",
    x: 49.562,
    y: 20.408,
    width: 10.313,
    height: 1.508,
    rx: 0.754
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#23A9F6",
    x: 8.312,
    y: 26.741,
    width: 13.042,
    height: 1.508,
    rx: 0.754
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#23A9F6",
    x: 37.126,
    y: 26.741,
    width: 21.838,
    height: 1.508,
    rx: 0.754
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#23A9F6",
    x: 7.402,
    y: 33.074,
    width: 32.151,
    height: 1.508,
    rx: 0.754
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#23A9F6",
    x: 45.922,
    y: 33.074,
    width: 11.526,
    height: 1.508,
    rx: 0.754
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 193 40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.676 34c-4.26-4.445-5.024-7.634-2.291-9.567 4.098-2.899 12.028-5.519 11.598-11.84C31.553 6.273 26.9 1.5 20.385.303 13.869-.896 6.585 1.57 2.74 5.79c-3.845 4.222-3.775 8.73 1.047 14.293C7 23.794 13.297 28.432 22.676 34z",
    fill: "url(#epyougw1sz)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#23A9F6",
    x: 4.233,
    y: 9.376,
    width: 14.289,
    height: 1,
    rx: 0.411
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#23A9F6",
    x: 22.027,
    y: 9.376,
    width: 4.583,
    height: 1,
    rx: 0.411
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#23A9F6",
    x: 3.694,
    y: 12.286,
    width: 5.797,
    height: 1,
    rx: 0.411
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#23A9F6",
    x: 16.501,
    y: 12.286,
    width: 9.706,
    height: 1,
    rx: 0.411
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#23A9F6",
    x: 3.29,
    y: 15.196,
    width: 14.289,
    height: 1,
    rx: 0.411
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#23A9F6",
    x: 20.41,
    y: 15.196,
    width: 5.123,
    height: 1,
    rx: 0.411
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33 145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.424 27c-3.46-3.53-4.082-6.062-1.862-7.597 3.33-2.302 9.774-4.383 9.424-9.402-.35-5.02-4.13-8.81-9.424-9.76C11.27-.712 5.35 1.246 2.226 4.598c-3.124 3.352-3.067 6.932.85 11.35C5.689 18.895 10.805 22.58 18.425 27z",
    fill: "url(#4wo3kjwdkA)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#23A9F6",
    x: 3.44,
    y: 7.446,
    width: 11.61,
    height: 1,
    rx: 0.328
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#23A9F6",
    x: 17.897,
    y: 7.446,
    width: 3.724,
    height: 1,
    rx: 0.328
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#23A9F6",
    x: 3.001,
    y: 9.757,
    width: 4.71,
    height: 1,
    rx: 0.328
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#23A9F6",
    x: 13.407,
    y: 9.757,
    width: 7.886,
    height: 1,
    rx: 0.328
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#23A9F6",
    x: 2.673,
    y: 12.068,
    width: 11.61,
    height: 1,
    rx: 0.328
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#23A9F6",
    x: 16.583,
    y: 12.068,
    width: 4.162,
    height: 1,
    rx: 0.328
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 193 126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.51 38c-4.792-4.968-5.651-8.532-2.577-10.692 4.61-3.24 13.532-6.168 13.048-13.233S30.262 1.676 22.933.338C15.603-1 7.408 1.755 3.083 6.473c-4.326 4.717-4.247 9.756 1.177 15.974 3.616 4.145 10.7 9.33 21.25 15.553z",
    fill: "url(#fzhg8yzf3B)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#23A9F6",
    x: 4.763,
    y: 10.48,
    width: 16.075,
    height: 1,
    rx: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#23A9F6",
    x: 24.781,
    y: 10.48,
    width: 5.156,
    height: 1,
    rx: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#23A9F6",
    x: 4.156,
    y: 13.732,
    width: 6.521,
    height: 1,
    rx: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#23A9F6",
    x: 18.563,
    y: 13.732,
    width: 10.919,
    height: 1,
    rx: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#23A9F6",
    x: 3.701,
    y: 16.984,
    width: 16.075,
    height: 1,
    rx: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#23A9F6",
    x: 22.961,
    y: 16.984,
    width: 5.763,
    height: 1,
    rx: 0.46
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIaInterview);
export default __webpack_public_path__ + "static/media/IAInterview.4ea55388d43bd0140af87e8b286b894c.svg";
export { ForwardRef as ReactComponent };